import React from "react";
import ButtonLink from "../../../components/elements/ButtonLink";

const CTASection = () => {
  return (
    <section className="py-16 lg:py-20 bg-primary">
      <div className="container mx-auto px-4 py-20">
        <div className="w-full lg:w-6/12 xl:w-7/12 mx-auto">
          <h2 className="w-full lg:w-9/12 mx-auto text-3xl lg:text-4xl xl:text-5xl xl:leading-tight text-white text-center leading-snug font-mono font-semibold">
            Come work with a highly motivated team
          </h2>

          <p className="text-white mt-4 pb-8 text-base lg:text-lg font-mono mx-auto text-center w-10/12 lg:w-10/12">
            The Utiva Masterclass is designed to help you learn from leaders and
            experts in the tech space. We are hiring across over 20 countries,
            join Our Mission To Democratize Education.
          </p>

          <div className="mt-2 mx-auto flex justify-center">
            <ButtonLink
              title={"Join the team"}
              url="/careers"
              withDropShadow={false}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
